import styled from 'styled-components';

import { colors } from 'config/theme';

export const AlertWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 40px 45px;
  color: black;
`;

export const HR = styled.hr`
  clear: both;
  display: block;
  width: 100%;
  border: 1px solid ${colors.lightGray};
  height: 2px;
  margin-top: 30px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row;
  margin-top: 20px;
`;
